var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHearingSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 112 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_01",
    "data-name": 1,
    transform: "translate(-499 -56.076)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hearing",
    transform: "translate(508.289 83.241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12621",
    "data-name": "Path 12621",
    d: "M180.439,0a18.7,18.7,0,0,0-18.585,18.7V45.73A11.938,11.938,0,0,0,173.681,57.67a11.737,11.737,0,0,0,6.758-2.147,12.016,12.016,0,0,0,5.069-9.792c0-6.059,2.9-8.961,6.263-12.322,3.4-3.4,7.253-7.253,7.253-14.711A18.7,18.7,0,0,0,180.439,0Z",
    transform: "translate(-125.747)",
    fill: "#ffd9b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12622",
    "data-name": "Path 12622",
    d: "M331.923,45.73c0-6.059,2.9-8.961,6.263-12.322,3.4-3.4,7.253-7.253,7.253-14.711A18.7,18.7,0,0,0,326.854,0V55.523A12.016,12.016,0,0,0,331.923,45.73Z",
    transform: "translate(-272.163 0)",
    fill: "#fb9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10557",
    "data-name": "Group 10557",
    transform: "translate(23.168 21.278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12623",
    "data-name": "Path 12623",
    d: "M48.492,210.782l-1.511-3.023a8.847,8.847,0,0,0,0-15.826l1.511-3.023a12.227,12.227,0,0,1,0,21.872Z",
    transform: "translate(-46.981 -188.91)",
    fill: "#6a75b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10558",
    "data-name": "Group 10558",
    transform: "translate(20.145 27.323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12624",
    "data-name": "Path 12624",
    d: "M21.656,252.363l-1.511-3.023a2.088,2.088,0,0,0,0-3.735l1.511-3.023a5.468,5.468,0,0,1,0,9.781Z",
    transform: "translate(-20.145 -242.582)",
    fill: "#6a75b9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12625",
    "data-name": "Path 12625",
    d: "M233.681,61a11.841,11.841,0,0,0-11.827,11.827v8.448h1.69a1.691,1.691,0,0,1,1.69,1.69v1.69a3.384,3.384,0,0,1-3.379,3.379v3.379a6.765,6.765,0,0,0,6.758-6.758v-1.69a5.079,5.079,0,0,0-3.379-4.78V72.827A8.38,8.38,0,0,1,226.8,67.96a6.756,6.756,0,0,1,5.192,6.557h3.379a9.99,9.99,0,0,0-1.69-5.558,10.255,10.255,0,0,0-4-3.524,8.341,8.341,0,0,1,4-1.056,8.458,8.458,0,0,1,8.448,8.448c0,3.11-1.03,4.288-4.285,7.545a47.3,47.3,0,0,0-4.163,4.612,23.418,23.418,0,0,0-5.069,14.876h3.379a20.487,20.487,0,0,1,1.69-8.431,28.548,28.548,0,0,1,6.554-8.669c3.465-3.466,5.273-5.483,5.273-9.933A11.841,11.841,0,0,0,233.681,61Z",
    transform: "translate(-178.989 -54.129)",
    fill: "#fb9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10559",
    "data-name": "Group 10559",
    transform: "translate(54.692 6.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12626",
    "data-name": "Path 12626",
    d: "M338.681,72.827A11.841,11.841,0,0,0,326.854,61v3.379a8.458,8.458,0,0,1,8.448,8.448c0,3.11-1.03,4.288-4.285,7.545a47.3,47.3,0,0,0-4.163,4.612v6.445a28.548,28.548,0,0,1,6.554-8.669C336.872,79.293,338.681,77.277,338.681,72.827Z",
    transform: "translate(-326.854 -61)",
    fill: "#ff9680"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12627",
    "data-name": "Path 12627",
    d: "M326.854,131.659v5.558h1.69A9.99,9.99,0,0,0,326.854,131.659Z",
    transform: "translate(-326.854 -123.7)",
    fill: "#ff9680"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearingSmall);
export default __webpack_public_path__ + "static/media/hearing_small.099c1fe80b99a4eaf5fb4767db40f2b2.svg";
export { ForwardRef as ReactComponent };